// Typography units with conversion factors to point (pt)
export const typographyUnits = [
  { id: 'point', name: 'Point', symbol: 'pt', plural: 'Points', factor: 1 },
  { id: 'pixel', name: 'Pixel', symbol: 'px', plural: 'Pixels', factor: 0.75 },
  { id: 'pica', name: 'Pica', symbol: 'pc', plural: 'Picas', factor: 12 },
  { id: 'em', name: 'Em', symbol: 'em', plural: 'Ems', factor: 12 },
  { id: 'inch', name: 'Inch', symbol: 'in', plural: 'Inches', factor: 72 },
  { id: 'centimeter', name: 'Centimeter', symbol: 'cm', plural: 'Centimeters', factor: 28.3464567 },
  { id: 'millimeter', name: 'Millimeter', symbol: 'mm', plural: 'Millimeters', factor: 2.83464567 },
  { id: 'twip', name: 'Twip', symbol: 'twip', plural: 'Twips', factor: 0.05 },
  { id: 'cicero', name: 'Cicero', symbol: 'cc', plural: 'Ciceros', factor: 12.7878 },
  { id: 'didot', name: 'Didot Point', symbol: 'dd', plural: 'Didot Points', factor: 1.0660 },
];

export const popularTypographyConversions = [
  { from: 'point', to: 'pixel' },
  { from: 'pixel', to: 'point' },
  { from: 'point', to: 'pica' },
  { from: 'pica', to: 'point' },
  { from: 'point', to: 'inch' },
  { from: 'pixel', to: 'em' },
];

export const getUnitById = (id) => typographyUnits.find(unit => unit.id === id);

export const convertTypography = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert typography units and learn the conversion formula.`;
};
